// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__nvOx2","title":"styles_title__7rSWH","noTitle":"styles_noTitle__W54cX","links":"styles_links__vwiP3"};